import React from 'react'
import PropTypes from 'prop-types'

// Styles
import styles from './progressBar.module.scss'

const ProgressBar = (props) => {
  const { tasksCompleted, totalTasks } = props
  const completionPercentage = tasksCompleted / totalTasks * 100
  const customStyles = {
    width: `${completionPercentage}%`
  }
  return (
    <div className={styles.container}>
      <div className={styles.progressBar}>
        <div className={styles.progress} style={customStyles} />
      </div>
      <div
        className={styles.content}
      >{`${tasksCompleted} of ${totalTasks}`}
      </div>
    </div>
  )
}

ProgressBar.propTypes = {
  tasksCompleted: PropTypes.number,
  totalTasks: PropTypes.number
}

ProgressBar.defaultProps = {
  tasksCompleted: 0,
  totalTasks: 0
}

export default ProgressBar
